import { render, staticRenderFns } from "./ContenidoCurricula.vue?vue&type=template&id=8b2db7f4&"
import script from "./ContenidoCurricula.vue?vue&type=script&lang=js&"
export * from "./ContenidoCurricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports